import { Translate } from '../../../../shared/LanguageService';
import { NavItem, Dropdown } from 'react-bootstrap';
import * as React from 'react';
import * as Features from '../../../../shared/Features';
import ImpersonateButton from '../../../../components/ImpersonateButton';
import PhotographerModal from "../../../photographers/PhotographerModal";

interface IPhotographerImpersonationDropdown {
    user: any;
    name: string;
    id: number;
    navigateTo: (path: string) => void;
}

export default class PhotographerImpersonationDropdown extends React.Component<IPhotographerImpersonationDropdown, any> {
    constructor(props: IPhotographerImpersonationDropdown, context: any) {
        super(props, context);
        this.state = { showModal: false };
    }

    render() {
        return (
            <div>
                {Features.hasAnyFeature(
                    [Features.Impersonation, Features.UpdatePhotographers],
                    this.props.user
                ) && (
                    <Dropdown id="photographer-dropdown">
                        <Dropdown.Toggle>
                            <i className="material-icons">photo_camera</i> {this.props.name}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {Features.hasFeature(Features.Impersonation, this.props.user) && (
                                <ImpersonateButton
                                    userId={this.props.id}
                                    type="MenuItem"
                                    skipRedirect
                                />
                            )}
                            {Features.hasFeature(
                                Features.UpdatePhotographers,
                                this.props.user
                            ) && (
                                <NavItem onClick={() => this.setState({ showModal: true })}>
                                    <i className="material-icons">edit</i> {Translate('orders/view/common/dropdown/edit')}
                                </NavItem>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                )}
                {!Features.hasAnyFeature(
                    [Features.Impersonation, Features.UpdatePhotographers],
                    this.props.user
                ) && (
                    <span>
                        <i className="material-icons">photo_camera</i> {this.props.name}
                    </span>
                )}
                {this.state.showModal && (
                    <PhotographerModal
                        showModal={this.state.showModal}
                        toggleModal={() => this.setState({ showModal: false })}
                        userId={this.props.id}
                    />
                )}
            </div>
        );
    }
}


/*
{bookingInfo &&
                                        bookingInfo.bookableOrderType.value ===
                                        BookableOrderTypes.Photo && (
                                            <i
                                                style={{marginRight: '6px'}}
                                                className="material-icons"
                                            >
                                                photo_camera
                                            </i>
                                        )}
                                    {bookingInfo &&
                                        bookingInfo.bookableOrderType.value ===
                                        BookableOrderTypes.Styling && (
                                            <i
                                                style={{marginRight: '6px'}}
                                                className="material-icons"
                                            >
                                                style
                                            </i>
                                        )}

                                    {(site === Site.getSiteName(Site.SE360) ||
                                            (Features.hasFeature(
                                                    Features.ViewBookedScandphotoPhotographerInfoRegardlessTime,
                                                    user
                                                ) ||
                                                (site === Site.getSiteName(Site.Scandphotos) &&
                                                    moment(bookingInfo.bookedTime.localDateTime).diff(
                                                        moment(),
                                                        'hours',
                                                        true
                                                    ) < 24))) &&
                                        bookingInfo.photographerName}

                                    {site === Site.getSiteName(Site.Scandphotos) &&
                                        !Features.hasFeature(
                                            Features.ViewBookedScandphotoPhotographerInfoRegardlessTime,
                                            user
                                        ) &&
                                        moment(bookingInfo.bookedTime.localDateTime).diff(
                                            moment(),
                                            'hours',
                                            true
                                        ) > 24 && (
                                            <i className="blur">
                                                {Translate(
                                                    'view-order/basic-order-info/photographer/will-be-revealed'
                                                )}
                                            </i>
                                        )}
 */